import React from 'react';

import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const GeoPinIcon = ({
  title = 'GeoPin',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 18 23" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M9.25.507C4.456.507.583 4.475.583 9.352c0 3.22 2.585 7.357 7.683 12.633.538.556 1.43.556 1.968 0l.437-.456c4.809-5.059 7.246-9.05 7.246-12.177 0-4.877-3.873-8.845-8.667-8.845zm0 2.737c3.268 0 5.93 2.727 5.93 6.108l-.002.103c-.06 2.047-1.887 5.15-5.53 9.155l-.398.433-.014-.015C5.273 14.75 3.32 11.467 3.32 9.352c0-3.381 2.663-6.108 5.93-6.108zm0 1.368a4.105 4.105 0 100 8.21 4.105 4.105 0 000-8.21zm0 2.737a1.368 1.368 0 110 2.737 1.368 1.368 0 010-2.737z" />
  </CreateIconComponent>
);

export default GeoPinIcon;
